import { render, staticRenderFns } from "./accountCreation.component.vue?vue&type=template&id=7b4d445b"
import script from "./accountCreation.component.ts?vue&type=script&lang=ts&external"
export * from "./accountCreation.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b4d445b')) {
      api.createRecord('7b4d445b', component.options)
    } else {
      api.reload('7b4d445b', component.options)
    }
    module.hot.accept("./accountCreation.component.vue?vue&type=template&id=7b4d445b", function () {
      api.rerender('7b4d445b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/accountCreation/accountCreation.component.vue"
export default component.exports